import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IVersionUpdatesVM } from '@mobile-data-access-view-models';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Router } from '@angular/router';

@Component({
  selector: 'ncis-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'VERSION_PAGE',
        alias: 'VERSION_PAGE',
      },
    }
  ]
})
export class VersionComponent {
  @Output()
  public readonly continueEvent = new EventEmitter();

  @Input()
  public versionUpdates!: IVersionUpdatesVM;

  constructor(private router: Router) {}

  public get showBottom(): boolean {
    const length = this.versionUpdates?.features?.length;

    if (!length) {
      return false;
    }

    return length > 1;
  }

  public get showDescription(): boolean {
    const url = this.router.url;
    if (url.includes('/home/dashboard')) {
      return false;
    }
    return true;
  }
}
